import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';
import { DialogActions } from 'src/app/model/dictionary';

export interface OverwriteAffectedEntry {
  id: number;
  version?: number;
}

export interface CreateDocOverwriteDialogData {
  mode: 'doc' | 'td';
  language: string;
  totalCount: number;
  affectedEntries: OverwriteAffectedEntry[];
  isPackagingSystem: boolean;
}

export interface CreateDocOverwriteDialogResult {
  event: DialogActions;
  createAll: boolean;
}

@Component({
  selector: 'app-create-doc-overwrite-dialog',
  templateUrl: './create-doc-overwrite-dialog.component.html',
  styleUrls: ['./create-doc-overwrite-dialog.component.scss'],
})
export class CreateDocOverwriteDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<CreateDocOverwriteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateDocOverwriteDialogData,
    private readonly translateService: TranslocoService
  ) {}

  get affectedCount(): number {
    return this.data.affectedEntries.length;
  }

  get missingCount(): number {
    return Math.max(0, this.data.totalCount - this.affectedCount);
  }

  get documentTypeLabel(): string {
    return this.translateService.translate(this.data.mode === 'doc' ? 'ppwrDocuments.typeDoc' : 'ppwrDocuments.typeTd');
  }

  get languageName(): string {
    return this.translateService.translate('language.' + (this.data.language === 'en' ? 'gb' : this.data.language));
  }

  onCancel(): void {
    this.dialogRef.close({ event: DialogActions.REJECT, createAll: false });
  }

  onCreateAll(): void {
    this.dialogRef.close({ event: DialogActions.CONFIRM, createAll: true });
  }

  onCreateMissing(): void {
    this.dialogRef.close({ event: DialogActions.CONFIRM, createAll: false });
  }
}
